/// <amd-module name="VSSUI/Coin" />
export { Coin } from "./Components/Coin/Coin";
export { ICoinProps, CoinSize } from "./Components/Coin/Coin.Props";
